export default "b.text-center {\n  display: block;\n}"